module.exports = __webpack_public_path__ + "img/pr-5.fc6ab64f.png";